import '.dt{line-height:var(--line-height-body);}.ssr-plugin'
import '.b8{margin-top:0px;}.ssr-plugin'
import '.ds{margin-bottom:1.5rem;}.ssr-plugin'
import { styled, Style } from 'inlines'

type ListStyleType = 'bullet' | 'check'

interface UnorderedListProps extends React.HTMLAttributes<HTMLUListElement> {
  style?: Style
  listStyle?: ListStyleType
}

const listStyleVariants: Record<ListStyleType, Style> = {
  bullet: {},
  check: {
    listStyle: 'none',
    paddingLeft: '1.5rem',
    '& > li': {
      position: 'relative',
      paddingLeft: '0.5rem',
      marginTop: 0,
      marginBottom: '1rem',
      '&::before': {
        content: '"✓"',
        position: 'absolute',
        left: '-1.5rem',
      },
    },
  },
}

export const UnorderedList = ({
  children,
  style,
  listStyle = 'bullet',
  ...rest
}: UnorderedListProps) => {
  return (
    <styled.ul className="dt b8 ds"
      {...rest}
      style={{
        '& > li': { marginTop: 0, marginBottom: '1rem' },
        ...listStyleVariants[listStyle],
        ...style,
      }}
    >
      {children}
    </styled.ul>
  )
}
